module.exports = __webpack_public_path__ + "img/6.a4fa828a.png";